'use es6';

import { FETCH } from 'dashboard-lib/public/request/request-type';
import { createRequestAction } from 'dashboard-lib/public/request/create-request-action';
import { getTeamHierarchy } from 'dashboard-lib/public/team/team-dao';
export const namespace = 'team-hierarchy';
export const fetchTeamHierarchy = createRequestAction(`${namespace}_${FETCH}`, getTeamHierarchy);
export const fetchTeamHierarchyActions = fetchTeamHierarchy.actions;